import './event-group.style.sass';
import template from './event-group.tpl.pug';

export default {
    selector: 'dbAEventGroup',
    template: template(),
    bindings: {
        count: '<',
        note: '<',
        value: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/event-group/event-group.cmpt.js